
export default {

    computed: {
        /**
         * 商品状态
         */
        getProductStatus() {
            return [{
                label: this.$t('erp.setting.goods_status_0', 0, { defaultValue: '全部' }),
                value: null,
            }, {
                label: this.$t('erp.setting.goods_status_1', 1, { defaultValue: '可用' }),
                value: '1',
            }, {
                label: this.$t('erp.setting.goods_status_2', 2, { defaultValue: '停用' }),
                value: '0',
            }]
        },
        getCheckStatus() {
            return [ {
                label: this.$t('fbb.inbound.check_pending',{defaultValue:'待审核'}),
                value: '0',
            },{
                label: this.$t('fbb.inbound.pass_audit',{defaultValue:'审核通过'}),
                value: '1',
            },{
                label: this.$t('erp.product.check_refused',{defaultValue:'审核驳回'}),
                value: '2',
            },{
                label: this.$t('erp.product.warehouse_error',{defaultValue:'仓库复测异常'}),
                value: '3',
            },{
                label: this.$t('erp.b2c.ignore_approved',{defaultValue:'暂不处理'}),
                value: '4',
            },]
        },
        /**
         * 产品类型
         */
        getProductType() {
            return [{
                label: this.$t('erp.setting.goods_type_0', 0, { defaultValue: '成品' }),
                value: '1',
            }, {
                label: this.$t('erp.setting.goods_type_1', 1, { defaultValue: '配件' }),
                value: '2',
            }, {
                label: this.$t('erp.setting.goods_type_2', 2, { defaultValue: '耗材' }),
                value: '3',
            }]
        },
        /**
        * 客退处理方式
        */
        getReturnDealMethod() {
            return [
                {value:2, label:this.$t('erp.product.destruction',{defaultValue:'销毁'})},
                {value:1,label:this.$t('erp.product.handing_method_for_damage_of_return_first_warehousing', { defaultValue: '拍照确认' })},
                {value:0,label:this.$t('erp.product.handing_method_for_damage_of_return_undetermined', { defaultValue: '客户自提' })},
            ];
        },
        /**
        * 是否需要签收服务
        */
        getIsSignService() {
            return [{
                label: this.$t('erp.global.yes', 0, { defaultValue: '是' }),
                value: '1',
            }, {
                label: this.$t('erp.global.no', 1, { defaultValue: '否' }),
                value: '0',
            }]
        },
        /**
       * 快递保价
       */
        getIsInsurance() {
            return [{
                label: this.$t('erp.global.yes', 0, { defaultValue: '是' }),
                value: 'Y',
            }, {
                label: this.$t('erp.global.no', 1, { defaultValue: '否' }),
                value: 'N',
            }]
        },
        // 入库是否打托
        getIsWarehousingPallet () {
            return [
                {
                    label: "Y",
                    value: 1
                },
                {
                    label: "N",
                    value: 0
                }
            ];
        },
        getChargeSizeType () {
            return [
                {
                    label: this.$t("erp.product.chargesizetype_0", { defaultValue: "常规品" }),
                    value: 0,
                    theme: "tag-deepgreen tagSize"
                },
                {
                    label: this.$t("erp.product.chargesizetype_1", { defaultValue: "超大异形品" }),
                    value: 1,
                    theme: "tag-purple tagSize"
                },
                {
                    label: this.$t("erp.product.chargesizetype_2", { defaultValue: "异形品" }),
                    value: 2,
                    theme: "tag-blue tagSize"
                }
            ];
        },
    }
}
